import { ImageSliderSlide } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../__mocks__/storyblok/createStoryblokAsset'

/**
 * Creates a mock ImageSliderSlide
 * @param overrides - Partial fields to override defaults
 * @returns Complete ImageSliderSlide mock
 */
export function createImageSliderSlide(
  overrides: Partial<ImageSliderSlide> = {}
): ImageSliderSlide {
  return {
    Image: createStoryblokAsset({
      filename:
        'https://a.storyblok.com/f/235453/769x466/dc9bf8d3e3/dummy_slider_769x466_01.jpeg',
      alt: 'A serene landscape with mountains in the background',
      copyright: 'John Doe Photography',
      id: 1,
      name: 'Serene Landscape',
      title: 'The Serenity of Nature',
      focus: 'center',
      src: 'https://a.storyblok.com/f/235453/769x466/dc9bf8d3e3/dummy_slider_769x466_01.jpeg',
      width: 769,
      height: 466,
      aspect_ratio: 1.65,
      content_type: 'image/jpeg',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    _uid: 'unique_string_identifier_123',
    component: 'image-slider-slide',
    ...overrides,
  }
}
